import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFileText"><Path fillRule="evenodd" clipRule="evenodd" d="M12 10H20V21.25C20 21.6642 19.6642 22 19.25 22H4.75C4.33579 22 4 21.6642 4 21.25V2.75C4 2.33579 4.33579 2 4.75 2H12V10ZM8 19H16V17.5H8V19ZM8 15H13V13.5H8V15Z" fill="currentColor"/><Path d="M19.5605 8.5H13.5V2.43945L19.5605 8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileText;
